module.exports = __webpack_public_path__ + "static/media/Storage-how-it-works-5.87d93931.jpg";